import React from "react";
import { Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Collapsible from "react-collapsible";
import "./Sidebar.css";

// Ícone de fechar personalizado
const CloseIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="close-icon"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const Sidebar = ({ show, handleClose }) => {
  return (
    <>
      <div>
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          className="side__bar"
        >
          <Offcanvas.Header>
            <button
              type="button"
              className="btn-close-custom"
              onClick={handleClose}
              aria-label="Fechar menu"
            >
              <CloseIcon />
            </button>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Collapsible
              trigger="Início"
              triggerTagName="div"
              triggerOpenedClassName="icon_close"
              triggerClassName="iconAdd"
              open={false}
            >
              <ul className="sidebar_sub_menu text-white mt-3">
                <li>
                  <NavLink to="/">Página Inicial</NavLink>
                </li>
              </ul>
            </Collapsible>

            <Collapsible
              trigger="Ginecologia"
              triggerTagName="div"
              triggerOpenedClassName="icon_close"
              triggerClassName="iconAdd"
              open={false}
            >
              <ul className="sidebar_sub_menu text-white mt-3">
                <li>
                  <NavLink to="/anticoncepcao">Anticoncepção</NavLink>
                </li>
                <li>
                  <NavLink to="/insercaoTrocaDIUsImplanon">
                    Inserção / Troca DIUs e Implanon
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/primeiraConsulta">
                    Primeira consulta ginecológica
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/rotinaGinecologica">
                    Rotina ginecológica
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/sosGinecologistaOnline">
                    S.O.S Ginecologista
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/avaliacaoFertilidade">
                    Avaliação da fertilidade
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/investigacaoInfertilidade">
                    Investigação da infertilidade
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/reposicaoHormonal">
                    Reposição hormonal na menopausa
                  </NavLink>
                </li>
              </ul>
            </Collapsible>

            <Collapsible
              trigger="Obstetrícia"
              triggerTagName="div"
              triggerOpenedClassName="icon_close"
              triggerClassName="iconAdd"
              open={false}
            >
              <ul className="sidebar_sub_menu text-white mt-3">
                <li>
                  <NavLink to="/consultoriaPreNatal">
                    Pré-Natal à Distância
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/suplementacaoPreGestacional">
                    Suplementação Pré Gestacional
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/suplementacaoNaGestacao">
                    Suplementação Na Gestação
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/suplementacaoPosParto">
                    Suplementação Pós Parto
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/diabetesGestacional">
                    Consultoria em Diabetes Gestacional
                  </NavLink>
                </li>
              </ul>
            </Collapsible>

            <Collapsible
              trigger="Como funciona"
              triggerTagName="div"
              triggerOpenedClassName="icon_close"
              triggerClassName="iconAdd"
              open={false}
            >
              <ul className="sidebar_sub_menu text-white mt-3">
                <li>
                  <a href="/#howitworks" onClick={handleClose}>
                    Entenda o processo
                  </a>
                </li>
              </ul>
            </Collapsible>

            <Collapsible
              trigger="Contato"
              triggerTagName="div"
              triggerOpenedClassName="icon_close"
              triggerClassName="iconAdd"
              open={false}
            >
              <ul className="sidebar_sub_menu text-white mt-3">
                <li>
                  <a href="https://wa.me/11958799090">WhatsApp</a>
                </li>
                <li>
                  <NavLink to="/contact">Fale Conosco</NavLink>
                </li>
              </ul>
            </Collapsible>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default Sidebar;
